import React from 'react';
import { useSettingsStore } from '../store';

// Пилюля «Кешбэк N ₽» рядом с ценой: сколько баллов вернется с покупки (1 балл = 1 ₽).
// Процент — публичный settings.referral.cashbackPercent; скрывается, если программа
// выключена или сумма кешбэка < 1 ₽.
export const CashbackBadge: React.FC<{ price: number; size?: 'sm' | 'md' }> = ({
  price,
  size = 'md',
}) => {
  const referral = useSettingsStore((s) => s.settings.referral);
  if (referral?.enabled === false) return null;
  const percent = referral?.cashbackPercent ?? 3;
  const amount = Math.floor((price * percent) / 100);
  if (amount < 1) return null;

  const sm = size === 'sm';
  return (
    <span
      className="inline-flex items-center flex-shrink-0 rounded-md font-bold"
      style={{
        gap: sm ? '3px' : '4px',
        padding: sm ? '2px 5px' : '3px 6px',
        fontSize: sm ? '11px' : '13px',
        lineHeight: '16px',
        background: '#EEF1FE',
        color: '#3657F0',
      }}
    >
      <svg width={sm ? 10 : 12} height={sm ? 12 : 14} viewBox="0 0 24 24" fill="none">
        <path
          d="M13 2 4 14h6l-1 8 9-12h-6l1-8z"
          stroke="#3657F0"
          strokeWidth="2.4"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
      </svg>
      Кешбэк {amount.toLocaleString('ru-RU')} ₽
    </span>
  );
};
